
// Import configuration (replaces WordPress globals)
import { jinkosoft_app_data } from '../config.js'
import {useLocaleStore} from "@/composables/useLocaleStore.js";
import {defineStore} from "pinia";

export const useSettingsStore = defineStore('settings', () => {

    const localeStore = useLocaleStore()

    const settings = reactive({
        translatableLocales     : [],
        selectedLanguage        : null,
        missingImage            : '/src/assets/images/missing-image.jpg',
        languages               : {},
        pcs_brackets            : [],
        isFront                 : false,
        isLoggedIn              : jinkosoft_app_data.is_logged_in,
        adminUsername           : jinkosoft_app_data.admin_username,
    })

    const loadSettings = async () => {

        await localeStore.loadLocales()

        // Build translatableLocales and languages from database locales
        const translatableLocales = []
        const languages = {}

        if (localeStore.locales) {
            localeStore.locales.forEach(locale => {
                translatableLocales.push(locale.code)
                languages[locale.code] = {
                    name: locale.name,
                    code: locale.code
                }
            })
        }

        settings.translatableLocales    = translatableLocales
        settings.languages              = languages
        settings.selectedLanguage       = localeStore.getSelectedLanguage()
        settings.pcs_brackets           = localeStore.graphqlSettings?.pcs_brackets ?? []
    }

    return {
        settings,

        loadSettings
    }
})